import { FONT } from "@/styles/common";
import theme from "@/styles/theme";
import { Flex, FormLabel, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useController } from "react-hook-form";
import { Input } from "../input";
import { CustomWrapper } from "./formElement.style";
import { FormElementProps } from "./formElement.type";

export const FormElement = ({
    control,
    label,
    className,
    isRequired,
    name,
    type = "text",
    ...restProps
}: FormElementProps) => {
    const {
        field,
        fieldState: { error },
    } = useController({ control, name });

    return (
        <CustomWrapper className={className ? `form_element ${className} ${type}` : `form_element ${type}`}>
            <FormLabel htmlFor={name} />
            <Flex gap="4px">
                {label && (
                    <Text fontSize="14px" color={theme.COLOR.gray[500]} as={"span"}>
                        {label}
                    </Text>
                )}
                <Text color={theme.COLOR.positive[200]} as={"span"}>
                    {isRequired ? "*필수 입력항목" : "*선택 입력항목"}
                </Text>
            </Flex>
            <Flex flexDir="column">
                <Input type={type} {...restProps} {...field} />
                {error && <ErrorText mt="4px">{error.message}</ErrorText>}
            </Flex>
        </CustomWrapper>
    );
};

export const ErrorText = styled(Text)`
    color: ${({ theme }) => theme.COLOR.negative};
    ${FONT("pretendard", 14, 500)}
`;
